import YearChooser from "../factures/components/YearChooser";
import _ from "underts";
import { Route, Switch, useLocation } from "wouter";
import GrandLivreComp from "./GrandLivreComp.tsx";
import { useEffect } from "react";

interface GrandLivreMainPanelProps {
  yearSelected: number;
  onSetYear: (year: number) => void;
}

const GrandLivreMainPanel = ({
  yearSelected: globalYearSelected,
  onSetYear,
}: GrandLivreMainPanelProps) => {
  const currentYear = new Date().getFullYear();
  const yearProposed = _.range(5, -1, -1).map((i) => currentYear - i);
  const [location, setLocation] = useLocation();
  const yearSelected = _.parseInt(location.split("/")[1]);
  const handleSelectYear = (year: number) => {
    onSetYear(year);
    setLocation("/" + year);
  };

  useEffect(() => {
    if (!yearSelected) {
      setLocation("/" + globalYearSelected, { replace: true });
      return;
    }

    if (yearSelected !== globalYearSelected) {
      setLocation("/" + globalYearSelected, { replace: true });
    }
  }, [globalYearSelected, setLocation, yearSelected]);

  return (
    <div>
      <div>
        <YearChooser
          yearSelected={yearSelected}
          yearChoices={yearProposed}
          onYearSelected={handleSelectYear}
        />
      </div>
      <Switch>
        <Route path={"/:year"} nest>
          <GrandLivreComp yearSelected={yearSelected as number} />
        </Route>
        {/*<Redirect to={"/" + globalYearSelected} replace />*/}
      </Switch>
    </div>
  );
};

export default GrandLivreMainPanel;
